import { END_POINTS, get } from '~/shared/http-client/api'
import { type ApiResponse } from '~/shared/http-client/exceptions/type'

// Response Type
export interface CircleListResponse extends ApiResponse {
  data: {
    pageInfo: {
      page: number
      row_per_page: number
      total_count: number
      max_page: number
      keyword: string
      category: string
      sort: string
      search: {}
      event_id: string
    }
    list: {
      id: number
      event_booth_application_id: number
      event_id: number
      user_id: number
      booth_status: string
      booth_name: string
      date_type: string
      date_type_desc: string
      booth_type: string
      booth_option_type: string
      zone_type: string
      zone_type_desc: string
      user_name: string
      user_email: string
      user_mobile: string
      etc: string
      image: number
      size_type: string
      complexity_type: string
      exp_type: string
      user_nickname: string
      goods_type: string
      genre_type: string
      delete_yn: string
      image_info: {
        id: number
        parent_table_key: string
        original_name: string
        url: string
      }
      homepage: string
      tag: string
    }[]
  }
}

export interface CircleInfoDetailResponse extends ApiResponse {
  data: {
    userBoothApplication: {
      id: number
      event_booth_application_id: number
      event_id: number
      user_id: number
      booth_status: string
      booth_name: string
      date_type: string
      booth_type: string
      booth_option_type: string
      zone_type: string
      user_name: string
      user_email: string
      user_mobile: string
      etc: string
      image: number
      size_type: string
      complexity_type: string
      exp_type: string
      user_nickname: string
      goods_type: string
      genre_type: string
      delete_yn: string
      homepage: string
      tag: string
      introduce: string
      booth_no: string
      image_info: {
        id: number
        parent_table_key: number
        original_name: string
        url: string
      }
      goods_list: {
        id: number
        parent_table_key: number
        original_name: string
        url: string
      }[]
    }
  }
}

export type BoothInfoListItem = {
  event_booth_application_info_category_id: number
  idx: number
  title: string
  body: string
}

export type BoothInfo = {
  id: number
  event_id: number
  sort: number
  category: string
  body: string
  list: BoothInfoListItem[]
  open_yn: string
}

export type BoothInfoResponse = {
  list: BoothInfo[]
}

export interface BoothInfoApiResponse extends ApiResponse {
  data: BoothInfoResponse
}

export const getCircleList = (
  rowPerPage: number,
  page: number,
  eventId: string,
  keyword: string,
) => {
  return get<CircleListResponse>(
    `/circle?row_per_page=${rowPerPage}&page=${page}&event_id=${eventId}&keyword=${keyword}`,
  )
}

export const getCircleInfoDetail = (id: string) =>
  get<CircleInfoDetailResponse>(`/circle/${id}`)

export const getCircleBoothInfo = async (
  eventId: string,
): Promise<BoothInfoResponse> => {
  const response: BoothInfoApiResponse = await get(
    `${END_POINTS.circleBooth.info}/${eventId}`,
  )

  return response.data
}
